import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  notification } from "antd";
import { apiServices } from "../../services/Api.js";


//get positions data
export const getPositionsData = createAsyncThunk(
    "position/getPositionsData",
    async (id) => {
        try {
            const response = await apiServices.post(`/customer/${id}/positions`);
            return response;
        } catch (error) {
            console.error("Error fetching positions data:", error);
            throw error;
        }
    }
);




const initialState = {
    data: [],
    loading: false,
    error: ""
};

const positionSlice = createSlice({
    name: "position",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getPositionsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPositionsData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = [action.payload];
            })
            .addCase(getPositionsData.rejected, (state) => {
                state.loading = false;
                state.error = "Error while fetching dashboard details";
                if (state.error) {
                    notification.error({
                        message: state.error
                    });
                }
            });
    },
});

const PositionReducer = positionSlice.reducer;

export default PositionReducer;
